import _ from 'lodash';

//For future reference, can use cleaner code from
//https://davidwalsh.name/query-string-javascript

export const getURLVal = (key) => {
  let result = [];
  const query = window.location.search.substring(1);
  const strings = query.split('&');
  _.each(strings, (string) => {
    const pair = string.split('=');
    let currKey = pair[0];
    if (currKey == key) {
      let currVal = pair[1] || '';
      currVal = currVal.replace('+', ' ');
      result.push(currVal);
    }
  });

  if(result.length===0){
    return null
  } else if (result.length===1) {
    return result[0]
  } else {
    return result
  }
}

export const parseUTMCodes = () => {
  const result = {};

  const params = window.location.search.substring(1);
  if(typeof params !== 'string' || !params) return result;
  const paramsDecoded = decodeURI(params);
  const paramsCleaned = paramsDecoded.trim().toLowerCase();
  const splitByCodes = paramsCleaned.split('&');

  _.each(splitByCodes, (param) => {
    if(typeof param !== 'string') return;

    if(!param.includes('utm')){
      return;
    }

    const split = param.split('=');
    const firstHalf = split[0];
    if(typeof firstHalf !== 'string') return;

    const utmKey = firstHalf.split('_')[1]
    const utmVal = split[1];
    if(!utmVal) return;

    const resultKey = 'utm_' + utmKey;
    result[resultKey] = utmVal;
  })

  return result;
}


// WEBPACK FOOTER //
// ./src/domains/URLDomain.js